import { BUDGET_SUB_TAB_CHANGED, SET_SELECTED_MAIN_TAB } from "./dashboard.js";

export const NET_SPENDING_TAB_CHANGED = 'NET_SPENDING_TAB_CHANGED';
export const SET_LOGIN_PAGE = 'SET_LOGIN_PAGE';
export const URL_POPSTATE = 'URL_POPSTATE';
export const TRANSACTIONS_VIEW_CHANGED = 'TRANSACTIONS_VIEW_CHANGED';

/** The transactions page's tabs: every transaction, or the duplicates cleanup at /dashboard/transactions/duplicates. */
export const transactionsViews = {
	ALL: 'all',
	DUPLICATES: 'duplicates',
	UNBUDGETED: 'unbudgeted',
};

export const transactionsViewChanged = (view) => ({
	type: TRANSACTIONS_VIEW_CHANGED,
	payload: view,
});

export function setLoginPage(loginPageName) {
	return {
		type: SET_LOGIN_PAGE,
		payload: loginPageName
	};
}

export function urlPopState(event) {
	return {
		type: URL_POPSTATE,
		payload: event,
	};
}

export const setSelectedMainTab = (tab) => {
	return {
		type: SET_SELECTED_MAIN_TAB,
		payload: tab
	};
};

export const budgetSubTabChanged = (tab) => {
	return {
		type: BUDGET_SUB_TAB_CHANGED,
		payload: tab,
	};
};

export const netSpendingTabChanged = (tab) => {
	return {
		type: NET_SPENDING_TAB_CHANGED,
		payload: tab,
	};
};